/**
 * 引渡担当者・登録担当者へ登録可能ユーザー(ドライバー以外のユーザー)
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/handle_users`

const search_handle_user = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_handle_user
